// GitHub's diff_hunk contains all lines from the start of the hunk up to the
// commented line, which can be the entire file diff for comments near the end
// of a large hunk. We keep only a trailing window so the preview stays compact.
const MAX_PREVIEW_LINES = 20;

export function truncateDiffHunk(diffHunk: string): string {
  const lines = diffHunk.split('\n');
  const hunkHeaderIndex = lines.findIndex((line) => line.startsWith('@@'));
  if (hunkHeaderIndex === -1) {
    return diffHunk;
  }

  const bodyLines = lines.slice(hunkHeaderIndex + 1);
  if (bodyLines.length <= MAX_PREVIEW_LINES) {
    return diffHunk;
  }

  const keptLines = bodyLines.slice(-MAX_PREVIEW_LINES);

  // Recompute the @@ header line numbers to match the truncated body.
  const hunkHeader = lines[hunkHeaderIndex]!;
  const headerMatch = hunkHeader.match(/^@@ -(\d+)(?:,\d+)? \+(\d+)(?:,\d+)? @@(.*)$/);
  if (!headerMatch) {
    return diffHunk;
  }

  const droppedLines = bodyLines.length - MAX_PREVIEW_LINES;

  // Count how many old-side and new-side lines were dropped so we can
  // advance the start line numbers in the reconstructed header.
  const droppedBody = bodyLines.slice(0, droppedLines);
  let droppedOld = 0;
  let droppedNew = 0;
  for (const line of droppedBody) {
    if (line.startsWith('-')) {
      droppedOld += 1;
    } else if (line.startsWith('+')) {
      droppedNew += 1;
    } else {
      // Context lines count on both sides
      droppedOld += 1;
      droppedNew += 1;
    }
  }

  const oldStart = Number(headerMatch[1]) + droppedOld;
  const newStart = Number(headerMatch[2]) + droppedNew;

  let oldCount = 0;
  let newCount = 0;
  for (const line of keptLines) {
    if (line.startsWith('-')) {
      oldCount += 1;
    } else if (line.startsWith('+')) {
      newCount += 1;
    } else {
      oldCount += 1;
      newCount += 1;
    }
  }

  const trailingContext = headerMatch[3] ?? '';
  const newHeader = `@@ -${oldStart},${oldCount} +${newStart},${newCount} @@${trailingContext}`;

  const preamble = lines.slice(0, hunkHeaderIndex);
  return [...preamble, newHeader, ...keptLines].join('\n');
}
